export default __webpack_public_path__ + "static/media/icon-oven-mode-normal.db353f61.svg";